import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getAddressAutocomplete } from '../api-ts';

export const MIN_AUTOCOMPLETE_ADDRESS_LENGTH = 7;
export const MAX_AUTOCOMPLETE_ADDRESS_LENGTH = 100;

/**
 * @param {String} partialAddress
 * @param {import('react-query').UseQueryOptions} useQueryOptions
 * @returns {import('react-query').UseQueryResult}
 */
export default function useGetAddressAutocomplete(partialAddress, useQueryOptions = {}) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['addressAutocomplete', partialAddress],
    queryFn: () => dispatch(getAddressAutocomplete({ partialAddress })),
    ...useQueryOptions,
    staleTime: 5 * 60 * 1000,
    enabled:
      partialAddress.trim().length >= MIN_AUTOCOMPLETE_ADDRESS_LENGTH &&
      partialAddress.trim().length <= MAX_AUTOCOMPLETE_ADDRESS_LENGTH,
  });
}
